import {
  AdminUnitAccessTreeNode,
  IeltsInCentreProductContextItem,
  IeltsOnlineNavigationState,
  UkviInCentreNavigationState,
  UkviOnlineNavigationState,
} from '@britishcouncil/common-store';
import { NavbarWrapper } from '@britishcouncil/react-navigation';
import { accessTreeClient } from 'api/planning';
import { useCallback } from 'react';
import { navigationSelectors, RootState } from 'store';
import { useSelector } from 'react-redux';
import { HiddenComponent, DebouncedLoader } from 'components';

export const Navbar = () => {
  const initialized = useSelector(navigationSelectors.getInitialized);
  const sortTree = useCallback(
    (treeNodeArray: AdminUnitAccessTreeNode[]): AdminUnitAccessTreeNode[] =>
      treeNodeArray
        .map((element) => ({ ...element, children: sortTree(element.children) }))
        .sort((a, b) => a.value.name.localeCompare(b.value.name)),
    []
  );

  const handleLoadPermittedProducts = () => {
    return Promise.resolve<string[]>([IeltsInCentreProductContextItem.id]);
  };

  const handleLoadAdminUnitAccessTree = useCallback(
    () => accessTreeClient.getAccessTree().then((x) => sortTree(x.data)),
    [sortTree]
  );

  return (
    <>
      <DebouncedLoader inline isFetching={!initialized} margin="0 1rem 0 1rem" />
      <HiddenComponent hidden={!initialized}>
        <NavbarWrapper
          primaryColor="#2185d0"
          productContextStateSelector={() => ({
            activeProductContext: IeltsInCentreProductContextItem,
            loading: false,
            permittedProducts: [IeltsInCentreProductContextItem],
          })}
          ieltsInCentreStateSelector={(s: RootState) => s.navigation}
          ieltsOnlineStateSelector={() => {
            return {} as IeltsOnlineNavigationState;
          }}
          ukviOnlineStateSelector={() => {
            return {} as UkviOnlineNavigationState;
          }}
          ukviInCentreStateSelector={() => {
            return {} as UkviInCentreNavigationState;
          }}
          loadPermittedProducts={handleLoadPermittedProducts}
          loadOnlineAdminUnitAccessTree={handleLoadAdminUnitAccessTree}
          loadInCenterAdminUnitAccessTree={handleLoadAdminUnitAccessTree}
          loadUkviOnlineAdminUnitAccessTree={handleLoadAdminUnitAccessTree}
          loadUkviInCentreAdminUnitAccessTree={handleLoadAdminUnitAccessTree}
        />
      </HiddenComponent>
    </>
  );
};
